import '../../sass/blocks/custom/layout/_header-hero.scss'
require('../../js/blocks/header-hero.js');